module.exports = __webpack_public_path__ + "static/media/sidebar8.6b3c204f.jpg";